module.exports = __webpack_public_path__ + "static/media/jump.e56214d1.jpg";